import * as AuthRole from "../../general/auth-role";
import { Avatar } from "material-ui";
import * as React from "react";
import { grey500, red500, white } from "material-ui/styles/colors";
import { NOT_SET } from "./need-approval-counter-updater";

export function data(user, needSigningCounter, newArticlesCounter) {
  let menus = [{ text: "Home", icon: null, link: "/app" }];

  let linkToPapers = "/app/referate/0";
  if (AuthRole.isBasic(user.authRole)) {
    if (user.isInApprovalFlow || user.canSeeAllPapers) {
      menus = menus.concat([
        { text: "Toate referatele", icon: null, link: linkToPapers }
      ]);
    } else if (user.department) {
      menus = menus.concat([
        { text: "Referatele mele", icon: null, link: linkToPapers }
      ]);
    }
  }

  if (user.isInApprovalFlow) {
    menus = menus.concat([
      {
        text: "Necesita aprobare",
        icon:
          needSigningCounter !== NOT_SET ? (
            <Avatar
              color={white}
              backgroundColor={needSigningCounter > 0 ? red500 : grey500}
              size={30}
              style={{ margin: 0, textAlign: "center" }}
            >
              {needSigningCounter}
            </Avatar>
          ) : null,
        link: "/app/need-approval"
      }
    ]);
  }

  if (AuthRole.isCompanyAdmin(user.authRole)) {
    menus = menus.concat([
      { text: "Setari autoritate", icon: null, link: "/app/admin/authority" },
      { text: "Setari produse", icon: null, link: "/app/admin/product" },
      { text: "Setari utilizatori", icon: null, link: "/app/admin/user" },
      {
        text: "Setari compartimente",
        icon: null,
        link: "/app/admin/department"
      },
      // {text: 'Setari roluri utilizatori', icon: null, link: '/app/admin/user-role'},
      // {text: 'Setari functii', icon: null, link: '/app/admin/user-position'},
      {
        text: "Setari categorii achizitie",
        icon: null,
        link: "/app/admin/acquisition-category"
      },
      {
        text: "Setari surse de finantare",
        icon: null,
        link: "/app/admin/finance-source"
      },
      { text: "Setari drepturi aprobare", icon: null, link: "/app/admin/flow" }
    ]);
  }

  if (AuthRole.canSeeContracts(user)) {
    menus.push({
      text: "Contracte",
      link: "/app/contracts"
    });
  }

  if (AuthRole.canSeeReports(user)) {
    menus.push({
      text: "Articole cumparate",
      icon:
        // not used anymore. Keeping the code
        // newArticlesCounter !== NOT_SET ? (
        //   <Avatar
        //     color={white}
        //     backgroundColor={newArticlesCounter > 0 ? red500 : grey500}
        //     size={30}
        //     style={{ margin: 0, textAlign: "center" }}
        //   >
        //     {newArticlesCounter}
        //   </Avatar>
        // ) : 
        null,
      link: "/app/reports/0"
    });
  }

  menus.push({ text: "Setari cont", icon: null, link: "/app/settings" });
  menus.push({ text: "Logout", icon: null, link: "/logout" });
  return menus;
}
